module.exports = __webpack_public_path__ + "img/chenggong.590aa8b3.png";